import {
  CLEAR_CANCEL_ORDER_ERROR,
  CLEAR_CANCEL_ORDER_STATE,
  CLEAR_INVOICE_DOWNLOAD_ERRORS,
  CLEAR_INVOICE_DOWNLOAD_STATE,
  CLEAR_ORDER_ERRORS,
  CLEAR_ORDER_PAYMENT_ERRORS,
  CLEAR_ORDER_PAYMENT_STATE,
  CLEAR_ORDER_STATE,
  CLEAR_UPDATE_ORDER_ERRORS,
  CLEAR_UPDATE_ORDER_STATE,
  GET_ORDER_INVOICE_FAIL,
  GET_ORDER_INVOICE_REQUEST,
  GET_ORDER_INVOICE_SUCCESS,
  GET_ORDER_LIST_FAIL,
  GET_ORDER_LIST_REQUEST,
  GET_ORDER_LIST_SUCCESS,
  ORDER_CANCEL_FAIL,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_PAYMENT_FAIL,
  ORDER_PAYMENT_REQUEST,
  ORDER_PAYMENT_SUCCESS,
  UPDATE_ORDER_ADDRESS_FAIL,
  UPDATE_ORDER_ADDRESS_REQUEST,
  UPDATE_ORDER_ADDRESS_SUCCESS,
} from "../constant/orderConstant";
import { axiosInstance } from "../../utils/config";

// CREATE NEW ORDER BY USER  STARTS
export const orderCreateAction =
  (
    items,
    createdBy,
    paymentMethod,
    shippingAddress,
    shippingMethod,
    discount,
    shippingCost,
    totalPrice,
    deliveryDate
  ) =>
    async (dispatch) => {
      try {
        dispatch({
          type: ORDER_CREATE_REQUEST,
        });

        const config = {
          headers: {
            "content-type": "application/json",
          },
        };

        const { data } = await axiosInstance.post(
          `/create-order`,
          {
            items,
            createdBy,
            paymentMethod,
            shippingAddress,
            shippingMethod,
            discount,
            shippingCost,
            totalPrice,
            deliveryDate,
          },
          config
        );
        dispatch({
          type: ORDER_CREATE_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: ORDER_CREATE_FAIL,
          payload: error.response.data.message,
        });
      }
    };

// CREATE NEW ORDER BY EDNS

// ORDER PAYMENT API STARTS
export const orderPaymentAction =
  (productOrder, shippingAddress, paymentMethod, coupon) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: ORDER_PAYMENT_REQUEST,
        });

        const config = {
          headers: {
            "content-type": "application/json",
          },
        };

        const { data } = await axiosInstance.post(
          `/initiate-payment`,
          {
            productOrder,
            shippingAddress,
            paymentMethod,
            coupon
          },
          config
        );
        dispatch({
          type: ORDER_PAYMENT_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: ORDER_PAYMENT_FAIL,
          payload: error.response.data.message,
        });
      }
    };
// ORDER PAYMENT API ENDS

// CANCEL ORDER
export const orderCancelRequest = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ORDER_CANCEL_REQUEST,
    });

    const config = {
      headers: {
        "content-type": "application/json",
      },
    };

    let { data } = await axiosInstance.put(`/cancel-order/${id}`, config);

    if (!data) {
      data = {
        success: false,
        message: "Someting went wrong, please try after sometime",
      };
    }

    dispatch({
      type: ORDER_CANCEL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ORDER_CANCEL_FAIL,
      payload: error.response.data.message,
    });
  }
};


// UPDATE ORDER ADDRESS STARTS 
export const updateOrderAddressAction =
  (
    shippingAddress,
    orderId
  ) =>
    async (dispatch) => {
      try {
        dispatch({
          type: UPDATE_ORDER_ADDRESS_REQUEST,
        });

        const config = {
          headers: {
            "content-type": "application/json",
          },
          withCredentials: true,
        };

        const { data } = await axiosInstance.put(
          `/order/${orderId}`,
          {
            shippingAddress,
          },
          config
        );

        dispatch({
          type: UPDATE_ORDER_ADDRESS_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: UPDATE_ORDER_ADDRESS_FAIL,
          payload: error.response.data.message,
        });
      }
    };

// GET USER ALL ORDER LIST  START
export const getAllOrderAction = (status, page) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ORDER_LIST_REQUEST,
    });

    const config = {
      headers: {
        "content-type": "application/json",
      },
      withCredentials: true,
    };
    let url = `page=${page}&limit=10`;

    if (status !== "all") {
      url += `&status=${status}`;
    }
    const { data } = await axiosInstance.get(`/my-orders?${url}`, config);

    dispatch({
      type: GET_ORDER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ORDER_LIST_FAIL,
      payload: error.response.data.message,
    });
  }
};
//   GET USER ALL ORDER LIST ENDS

// DOWNLOAD INVOICE STARTS
export const downloadOrderInvoice = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ORDER_INVOICE_REQUEST,
    });

    const config = {
      headers: {
        "content-type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await axiosInstance.get(`/order-invoice/${id}`, config);

    dispatch({
      type: GET_ORDER_INVOICE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ORDER_INVOICE_FAIL,
      payload: error.response.data.message,
    });
  }
};
// DOWLOAD INVOICE ENDS

export const clearOrderError = () => async (dispatch) => {
  dispatch({ type: CLEAR_ORDER_ERRORS });
};

export const clearOrderState = () => async (dispatch) => {
  dispatch({ type: CLEAR_ORDER_STATE });
};
export const clearInvoiceError = () => async (dispatch) => {
  dispatch({ type: CLEAR_INVOICE_DOWNLOAD_ERRORS });
};
export const clearInvoiceState = () => async (dispatch) => {
  dispatch({ type: CLEAR_INVOICE_DOWNLOAD_STATE });
};

export const clearOrderPaymentError = () => async (dispatch) => {
  dispatch({ type: CLEAR_ORDER_PAYMENT_ERRORS });
};
export const clearOrderPaymentState = () => async (dispatch) => {
  dispatch({ type: CLEAR_ORDER_PAYMENT_STATE });
};

export const clearUpdateOrderError = () => async (dispatch) => {
  dispatch({ type: CLEAR_UPDATE_ORDER_ERRORS });
};
export const clearUpdateOrderState = () => async (dispatch) => {
  dispatch({ type: CLEAR_UPDATE_ORDER_STATE });
};
export const clearCancelOrderState = () => async (dispatch) => {
  dispatch({ type: CLEAR_CANCEL_ORDER_STATE });
};
export const clearCancelOrderError = () => async (dispatch) => {
  dispatch({ type: CLEAR_CANCEL_ORDER_ERROR });
};
